import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

/**
 * Fetch Salary Head Master list
 */
export const fetchSalaryHeadMaster = createAsyncThunk(
    'payroll/fetchSalaryHeadMaster',
    async (limit: number = 200): Promise<any[]> => {
        const res = await axios.get(`/api/v1/payroll/salaryHead?limit=${limit}`);
        return res.data?.data || [];
    }
);

/**
 * Fetch Employee Salary Config (latest by effectiveFrom DESC)
 */
export const fetchEmployeeSalaryConfig = createAsyncThunk(
    'payroll/fetchEmployeeSalaryConfig',
    async ({ employeeId, limit = 10, sortLatest = false }: { employeeId: string; limit?: number; sortLatest?: boolean }): Promise<any[]> => {
        const sortParam = sortLatest ? `&sort=-effectiveFrom&_t=${Date.now()}` : '';
        const res = await axios.get(`/api/v1/payroll/employeeSalaryConfig?employee=${employeeId}&limit=${limit}${sortParam}`);
        return res.data?.data || [];
    }
);

/**
 * Fetch Salary Grade by ID
 */
export const fetchSalaryGradeById = createAsyncThunk(
    'payroll/fetchSalaryGradeById',
    async (gradeId: string): Promise<any> => {
        const res = await axios.get(`/api/v1/payroll/salaryGrade/${gradeId}`);
        return res.data?.data || res.data;
    }
);

/**
 * Fetch Employee Timesheet Monthly
 */
export const fetchEmployeeTimesheetMonthly = createAsyncThunk(
    'payroll/fetchEmployeeTimesheetMonthly',
    async ({ employeeId, year, month }: { employeeId: string; year: number; month: number }): Promise<any> => {
        const res = await axios.get(`/api/v1/employee/timesheet/monthly/${employeeId}`, {
            params: { year, month },
            headers: { 'x-silent': '1' }
        });
        return res.data;
    }
);

/**
 * Fetch Employee Daily Attendance (fallback)
 */
export const fetchEmployeeDailyAttendance = createAsyncThunk(
    'payroll/fetchEmployeeDailyAttendance',
    async ({ accountId, startDate, endDate, employeeId }: { accountId: string; startDate: string; endDate: string; employeeId: string }): Promise<any> => {
        const res = await axios.get(`/api/v1/employee/dailyAttendance`, {
            params: { accountId, startDate, endDate, employee: employeeId },
            headers: { 'x-silent': '1' }
        });
        return res.data;
    }
);

/**
 * Fetch Holidays in date range
 */
export const fetchHolidaysInRange = createAsyncThunk(
    'payroll/fetchHolidaysInRange',
    async ({ startDate, endDate }: { startDate: string; endDate: string }): Promise<any> => {
        const res = await axios.get(`/api/v1/holidays`, {
            params: { dateFrom: startDate, dateTo: endDate, isActive: true },
            headers: { 'x-silent': '1' }
        });
        return res.data;
    }
);
